import type { SanitizedConfig } from 'payload'

export default {} as Promise<SanitizedConfig>
